import { liveStatus } from '../api/client.ts';

/**
 * 데이터 상태 표시.
 *
 * 목업으로 돌고 있다는 사실을 숨기지 않습니다. 조용히 가짜 데이터를 보여주면
 * 저장이 왜 안 되는지 아무도 모르고, 버그 리포트가 엉뚱한 곳을 향합니다.
 */

/**
 * 목업 모드일 때 *왜* 목업인지까지 적습니다.
 *
 * 기기에서 이 배너를 보면 원인을 바로 알 수 있어야 합니다. 예전에는 그냥
 * "미리보기" 라고만 적혀 있어서, 앱 안에서 토큰이 유실된 것과 브라우저로 그냥
 * 열어 본 것이 화면상 구분되지 않았습니다.
 */
const REASON: Record<string, string> = {
  'no-token': '로그인 정보를 받지 못했습니다. 앱을 완전히 종료했다 다시 열어 주세요.',
  'no-api': '서버 주소가 설정되지 않은 빌드입니다.',
};

export function MockBanner() {
  const status = liveStatus();
  if (status === 'live') return null;
  return (
    <p className="banner">
      <b>미리보기</b> 예시 데이터입니다. 저장·수정은 반영되지 않습니다.
      <br />
      {REASON[status]}
    </p>
  );
}

export function Loading({ label = '불러오는 중' }: { label?: string }) {
  return (
    <div className="loading" role="status" aria-live="polite">
      <span className="loading__spinner" />
      <span className="loading__label">{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="empty">
      <p className="empty__title">불러오지 못했습니다</p>
      {/* 무엇이 잘못됐는지 그대로 보여줍니다. 사과문은 도움이 안 됩니다 */}
      <p className="empty__hint">{message}</p>
      <button type="button" className="btn btn--secondary btn--inline" onClick={onRetry}>
        다시 시도
      </button>
    </div>
  );
}
